// extracted by mini-css-extract-plugin
module.exports = {"lozenges":"filter-lozenge-group-module--lozenges--3da7w"};